const b2cKr = {
  kr: {},
};

export default b2cKr;
